/** shared/ui/chart 의 사용자 문구 */
export const CHART_TEXT = {
  /** TimeSeriesChart 덮개(overlay) 문구 — 그래프를 그릴 수 없을 때(Figma · 청사진 TimeSeriesChart) */
  overlay: {
    empty: '데이터가 없어 그래프가 표시되지 않습니다.',
    nan: '정성적 KPI로 그래프가 표시되지 않습니다.',
  },
  /** 세로축 단위 글자: "( 백만원 )" */
  unit: (unit: string) => `( ${unit} )`,
  /** 그래프를 읽어 줄 요약(role=img 의 aria-label) */
  summary: {
    timeSeries: (names: string[], first: string, last: string, count: number) =>
      `${names.join(' · ')} 그래프: ${first} ~ ${last}, ${count}기간`,
    timeSeriesEmpty: '그래프: 자료 없음',
    heatmap: (rows: number, columns: number, first?: string, last?: string) =>
      first && last
        ? `히트맵: ${rows}줄 · ${first} ~ ${last} ${columns}칸`
        : `히트맵: ${rows}줄 · ${columns}칸`,
    treemap: (groups: number, items: number) => `트리맵: 구간 ${groups}개 · 항목 ${items}개`,
    stackedBar: (labels: string[]) => `누적 막대 그래프: ${labels.join(' · ')}`,
  },
  /** Treemap status=empty 의 기본 문구 */
  treemapEmpty: '유효한 데이터가 없습니다.',
  /** GraphCard 기간 탭 */
  period: { quarter: '분기별', year: '연도별' },
  /** GraphCard 연결매출 스위치 글자 */
  connected: '연결매출',
  /** GraphCard 확대 단추 */
  expand: '그래프 크게 보기',
  /** GraphCard 기간 탭 묶음의 라벨 */
  periodTabs: '기간',
  /** GraphCard 코멘트 칸의 라벨: "<제목> 코멘트" */
  commentLabel: (title: string) => `${title} 코멘트`,
} as const;
